module.exports = __webpack_public_path__ + "img/enkonomiya.5b87cf05.jpg";